/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


export class RestoreAzureDiskConfig {
  /**
  * The type of the disk to restore
  */
  'diskType'?: string;
  /**
  * The tier of the disk to restore
  */
  'diskTier'?: string;
  /**
  * The Hyper-V generation of the disk to restore
  */
  'diskHyperVGeneration'?: string;
  /**
  * The size of the disk to restore in bytes
  */
  'diskSizeBytes'?: number;
  /**
  * Optional tags to apply to the output instance
  */
  'tags'?: { [key: string]: string; };

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "diskType",
      "baseName": "diskType",
      "type": "string",
      "format": ""
    },
    {
      "name": "diskTier",
      "baseName": "diskTier",
      "type": "string",
      "format": ""
    },
    {
      "name": "diskHyperVGeneration",
      "baseName": "diskHyperVGeneration",
      "type": "string",
      "format": ""
    },
    {
      "name": "diskSizeBytes",
      "baseName": "diskSizeBytes",
      "type": "number",
      "format": "int64"
    },
    {
      "name": "tags",
      "baseName": "tags",
      "type": "{ [key: string]: string; }",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return RestoreAzureDiskConfig.attributeTypeMap;
  }

  public constructor() {
  }
}

